import { type IBankAccount, type IWireBlotterRow, BANK_ACCOUNT_TYPES, WIRE_DIRECTIONS } from './types'

const bankAccountTypeOptions = BANK_ACCOUNT_TYPES.reduce(
  (acc, type) => ({ ...acc, [type]: type }),
  {} as Record<string, string>,
)

const wireDirectionOptions = WIRE_DIRECTIONS.reduce(
  (acc, direction) => ({ ...acc, [direction]: direction }),
  {} as Record<string, string>,
)

export const bankAccountInputs = (form: Partial<IBankAccount>): Record<string, any> => ({
  name: { inputType: 'text', title: 'Bank Account', value: form.name, required: true },
  glAccountNo: { inputType: 'text', title: 'GL Acct', value: form.glAccountNo, required: true },
  type: {
    inputType: 'select',
    title: 'Type',
    options: bankAccountTypeOptions,
    value: form.type,
    hasDefaultOption: false,
  },
})

export const wireBlotterInputs = (
  form: Partial<IWireBlotterRow>,
  loanOptions: Record<string, string>,
): Record<string, any> => ({
  wireDate: { inputType: 'text', type: 'date', title: 'Date', value: form.wireDate },
  direction: {
    inputType: 'select',
    title: 'Direction',
    options: wireDirectionOptions,
    value: form.direction,
    hasDefaultOption: false,
  },
  counterparty: { inputType: 'text', title: 'Counterparty', value: form.counterparty },
  loanId: {
    inputType: 'select',
    title: 'Loan',
    options: loanOptions,
    value: form.loanId,
    hasDefaultOption: true,
    defaultOptionText: 'Select',
  },
  amount: { inputType: 'text', type: 'number', title: 'Amount', value: form.amount, required: true },
  purpose: { inputType: 'text', title: 'Purpose', value: form.purpose },
})
